import React, { useState } from "react";

import "./TopBar.css";

import logo from "../../Images/Logo.webp";
import { Link } from "react-router-dom";
import { SidebarData } from "./SidebarData";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import CloseIcon from "@mui/icons-material/Close";

const TopBar = () => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-6">
            <Link to="/">
              
              <img src={logo} alt="" className="img_style" />
            </Link>
          </div>
          <div className="col-6">
            <div className="navbar text-right">
              <Link to="#" className="">
                <button className="navbtn">
                  <span onClick={showSidebar} id="hamburger-icon" title="Menu">
                    <span className="line line-1"></span>
                    <span className="line line-2"></span>
                    <span className="line line-3"></span>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
        <ul className="nav-menu-items" onClick={showSidebar}>
          <li className="navbar-toggle">
            <Link className="menu-bars">
              <CloseIcon sx={{ color:'#ffff',fontSize: 40, fontWeight: 600 }} />
            </Link>
          </li>
          {SidebarData.map((item, index) => {
            return (
              <li key={index} className={item.cName}>
                <Link to={item.path}>
                  <img src={item.icon} className="img-fluid menu_icon" alt="" />
                  <span>{item.title}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </>

    // <>
    //   <div className="navbarss d-flex p-5">
    //     <div className="p-2">
    //       <Link to="/">Logo</Link>
    //     </div>
    //     <div className="navbars ml-auto p-2">
    //       <Link to="#" className="menu-barss">
    //         <button onClick={showSidebar}>Open</button>
    //       </Link>
    //     </div>
    //   </div>

    //   <nav className={sidebar ? "nav-menus active" : "nav-menus"}>
    //     <ul className="nav-menu-itemss" onClick={showSidebar}>
    //       <li className="navbar-toggles">
    //         <Link to="#" className="menu-barss">
    //           <button>X</button>
    //         </Link>
    //       </li>

    //       {SidebarData.map((item, index) => {
    //         return (
    //           <li key={index} className={item.cName}>
    //             <Link to={item.path}>
    //               <span>{item.title}</span>
    //             </Link>
    //           </li>
    //         );
    //       })}
    //     </ul>
    //   </nav>
    // </>
  );
};

export default TopBar;
